import { BehaviorSubject, interval, Observable, Subscription } from 'rxjs';
import UserRepository from '@/repositories/UserRepository';

export default class GlobalState {
    private readonly _toastSubject = new BehaviorSubject<string | null>(null);
    private readonly _userRepository: UserRepository;
    private readonly _loginEndpoint: string;
    private readonly _keepAliveSubscription = new Subscription();

    public constructor(userRepository: UserRepository, loginEndpoint: string) {
        this._loginEndpoint = loginEndpoint;
        this._userRepository = userRepository;
        this._keepAliveSubscription = interval(10 * 60 * 1000).subscribe(() => this._userRepository.getSelf());
    }

    public beginLogin(): void {
        window.location.href = this._loginEndpoint;
    }

    public beginLogout(): void {
        this._userRepository.logout().subscribe((resource) => {
            if (resource.isSuccess && resource.data) {
                window.location.href = resource.data.logoutUrl;
            }
        });
    }

    public toast(message: string): void {
        this._toastSubject.next(message);
    }

    public get currentToast(): string | null {
        return this._toastSubject.value;
    }

    public get toastObservable(): Observable<string | null> {
        return this._toastSubject.asObservable();
    }
}
